// extracted by mini-css-extract-plugin
export default {"advBtn":"advBtn___Fm80u","advBtnIcon":"advBtnIcon___UbqfL","advBtnText":"advBtnText___s10IR"};